import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel, TcVm } from '../../../core/_infrastructure/types/common';

export class EmpresaDeshidratadoraViewModel {
    constructor() {}

    public Id: number;
    public NumeroRegistro: string;
    public NombreIndustria: string;
    public Direccion: string;
    public Activo: boolean;
    public IdMunicipio: number;
    public IdProvincia: number;
    public Desautorizada?: boolean;
    public CampaniasDesautorizado: TcVm[];
}

export class EmpresaDeshidratadoraItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: EmpresaDeshidratadoraItemViewModel[];
}

export class EmpresaDeshidratadoraItemViewModel {
    public Id: number;
    public NumeroRegistro: string;
    public NombreIndustria: string;
    // public Direccion: string;
    public Activo = true;
    public IdMunicipio: number | null;
    public IdProvincia: number | null;

    public IdProvinciaDescripcion: string;
    public IdMunicipioDescripcion: string;
    // Campo usado en la funcionalidad de gestión de recintos de la solicitud de campaña.
    // NO viajan al core
    public IdUsuario?: number;
    public MarkToDelete?: number;
    public DadoDeBaja?: number;
    public CampaniasDesautorizado: TcVm[];
}

export class FilterSearchingEmpresaDeshidratadoraViewModel extends FilterSearchingBaseViewModel {
    public Id: number;
    public NumeroRegistro: string;
    public NombreIndustria: string;
    public Direccion: string;
    public Activo: number = EnumSiNoTodos.TODOS;
    public Autorizada: number = EnumSiNoTodos.TODOS;
    public IdMunicipio: number | null;
    public IdProvincia: number | null;
    // Campos utilizados en el modo de búsqueda Embedded.
    // Este modo se utiliza cuando en el buscador de empresas deshidratadoras, está embebido en la pantalla de solicitudes de campaña.
    // En éste caso, se filtra también por Periodo. Si el usuario no filtra por provincia, se utilizará la CA configurada para el periodo.
    public IdPeriodoCam?: number;
    public IdCa?: number;
    public IdSolicitudCam?: number;
    public IdCampania?: number;
}

export class EmpresasListViewModel {
    public IdsEmpresa: number[];
}
